<div class="p-3 pt-2 rounded-4">
  <div>
    <div class="pTitle border-0 mb-0 rounded-bottom-0 rounded-4 p-0 d-flex justify-content-between">
      <div class="p-3">Currency</div>
      <button class="btn btn-info btn-sm bg-white me-3 mt-3 mb-3" (click)="addNew(content)">Add New</button>
    </div>
  </div>
  <div class="container-fluid">
    <div class="row bg-white p-2 pt-0">
      <div class="col-md-12 mt-4 mb-5">
        <div class="table-responsive">
          <ag-grid-angular style="width: 100%; height: 600px" class="ag-theme-alpine"
            [columnDefs]="columnDefs" [gridOptions]="gridOptions" (gridReady)="onGridReady($event)">
          </ag-grid-angular>
        </div>
      </div>
    </div>
  </div>
</div>


{{ setContent(content) }}

<ng-template #content let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{ dataObj._id ? "Edit Currency" : "New Currency" }}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="onClose()"></button>
  </div>
  <div class="modal-body">
    @if (errorMessage) {
      <div class="alert alert-danger" role="alert">{{ errorMessage }}</div>
    }
    <form #userForm="ngForm">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="required">Name</label>
              <input type="text" class="form-control" #currencyName="ngModel" name="name"
                [(ngModel)]="dataObj.name" required maxlength="50">
            </div>
            @if (currencyName.touched && currencyName.invalid) {
              <div class="text-danger">
                Please enter the name
              </div>
            }
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="required">Short Name</label>
              <input type="text" class="form-control" #shortName="ngModel" name="shortName"
                [(ngModel)]="dataObj.shortName" required maxlength="5">
            </div>
            @if (shortName.touched && shortName.invalid) {
              <div class="text-danger">
                Please enter the short name
              </div>
            }
          </div>
          <div class="col-md-6 mt-3">
            <div class="form-group">
              <label class="required">Symbol</label>
              <input type="text" class="form-control" #symbol="ngModel" name="symbol"
                [(ngModel)]="dataObj.symbol" required maxlength="10">
            </div>
            @if (symbol.touched && symbol.invalid) {
              <div class="text-danger">
                Please enter the symbol
              </div>
            }
          </div>


          <div class="col-md-6 mt-3">
            <div class="form-group">
              <label class="required">Status</label>
              <select class="form-control form-select" required name="status" #status="ngModel"
                [(ngModel)]="dataObj.status" required>
                <option value="Active">Active</option>
                <option value="InActive">In-Active</option>
              </select>
            </div>
            @if (status.touched && status.invalid) {
              <div class="text-danger">
                Please select status
              </div>
            }
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 mt-2 text-center">
            <button [disabled]="!userForm.valid" class="btn btn-primary active mt-4 w-50"
            (click)="onSubmit(userForm.valid)">Submit</button>
          </div>
        </div>
      </div>
    </form>
  </div>
</ng-template>